import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import * as React from 'react';
import { useAppSelector } from '../../../../redux/store';
import { AvatarDisplay } from './avatarDisplay';
/**
 * Only re-render the avatar if the uuid (which is generated and attached when an avatar is received in an inbound) is changing.
 */
function avatarEqualityFn(avatar1, avatar2) {
    return avatar1?.uuid === avatar2?.uuid;
}
const AvatarDisplayContainer = React.forwardRef(({ seatIndex }, ref) => {
    const seatedPlayerAvatar = useAppSelector((state) => state.poker.seatedPlayers[seatIndex]?.avatar, avatarEqualityFn);
    const baseAvatarScaleFactor = useAppSelector((state) => state.gameDimensions.baseAvatarScaleFactor);
    if (!seatedPlayerAvatar || baseAvatarScaleFactor === undefined) {
        return null;
    }
    return (_jsx(AvatarDisplay, { ref: ref, avatar: seatedPlayerAvatar, seatIndex: seatIndex, baseAvatarScaleFactor: baseAvatarScaleFactor }));
});
AvatarDisplayContainer.displayName = 'AvatarDisplayContainer';
export { AvatarDisplayContainer };
